import React from 'react'
import Banner from '../components/Ads/Banner'
import Shopfilter from '../components/Container/Shopfilter'
import ShopProducts from '../components/Container/ShopProducts.jsx'
import Footer from '../components/layout/Footer'
import Navbar from './Navbar'
import { useParams } from 'react-router-dom'
const Shop = () => {
  const {productList}=useParams();
  console.log("shop in : "+productList);
  return (
    <div>
      <Navbar/>
    <div className='w-full lg:p-4  flex'>
     <div className='hidden lg:block w-64 mr-2 '>
       <Shopfilter/>
     </div>
     <div className=' flex-grow'>
      <Banner/>
       <ShopProducts productList={productList} />
     </div>
    </div>
    <Footer/>
    </div>

  )
}

export default Shop